<template>
    <div>
        <y-timeline-node
            v-bind="nodeBind"
            alert
            :color="color"
            :icon="iconName"
            has-hood
        >
            <template #modal="data">
                <node-modal :content="data.content" />
            </template>
        </y-timeline-node>
    </div>
</template>

<script>
    import TimelineNode from '@/mixins/TimelineNode';
    import NodeModal from './NodeModal';

    export default {

        name: 'OrderEditedNode',

        components: {
            NodeModal,
        },

        mixins: [TimelineNode],

        computed: {
            /**
             * return whether a static icon or use a icon name from props
             */
            iconName() {
                return this.icon || 'md-pencil';
            },
        },

    };
</script>
